const EXERCISE_LOG_CLASS_NAME = 'ExerciseLog'

const EXERCISE_LOG_KEY = {
  LOGGED_AT: 'loggedAt',
  SET_COUNT: 'setCount',

  FIRST_TRAINING_VOLUME: 'firstTrainingVolume',
  MIN_TRAINING_VOLUME: 'minTrainingVolume',
  AVERAGE_TRAINING_VOLUME: 'averageTrainingVolume',
  MAX_TRAINING_VOLUME: 'maxTrainingVolume',
  TOTAL_TRAINING_VOLUME: 'totalTrainingVolume',
  LAST_TRAINING_VOLUME: 'lastTrainingVolume',

  FIRST_DURATION: 'firstDuration',
  LAST_DURATION: 'lastDuration',
  MIN_DURATION: 'minDuration',
  AVERAGE_DURATION: 'averageDuration',
  MAX_DURATION: 'maxDuration',
  TOTAL_DURATION: 'totalDuration',

  FIRST_REST: 'firstRest',
  LAST_REST: 'lastRest',
  MIN_REST: 'minRest',
  AVERAGE_REST: 'averageRest',
  MAX_REST: 'maxRest',
  TOTAL_REST: 'totalRest',

  FIRST_WEIGHT: 'firstWeight',
  LAST_WEIGHT: 'lastWeight',
  MIN_WEIGHT: 'minWeight',
  MIN_WEIGHT_DURATION: 'minWeightDuration',
  AVERAGE_WEIGHT: 'averageWeight',
  MAX_WEIGHT: 'maxWeight',
  TOTAL_WEIGHT: 'totalWeight',
  MAX_WEIGHT_DURATION: 'maxWeightDuration',
  WEIGHT_UNIT: 'weightUnit',

  FIRST_REPS: 'firstReps',
  LAST_REPS: 'lastReps',
  AVERAGE_REPS: 'averageReps',
  MIN_REPS: 'minReps',
  MAX_REPS: 'maxReps',
  MIN_WEIGHT_REPS: 'minWeightReps',
  MAX_WEIGHT_REPS: 'maxWeightReps',
  TOTAL_REPS: 'totalReps',

  // Associations
  EXERCISE: 'exercise',

  // Foreign keys
  EXERCISE_ID: 'exerciseId',
  PROFILE_ID: 'profileId',
  WORKOUT_ID: 'workoutId'
}

const EXERCISE_LOG_PRIVATE_KEYS = []
const EXERCISE_LOG_FOREIGN_KEYS = [
  EXERCISE_LOG_KEY.EXERCISE_ID,
  EXERCISE_LOG_KEY.PROFILE_ID,
  EXERCISE_LOG_KEY.WORKOUT_ID
]
const EXERCISE_LOG_ASSOCIATIONS = [
  EXERCISE_LOG_KEY.EXERCISE
]

const EXERCISE_LOG_SCOPE = {

  /**
   * Only returns the public attributes.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: EXERCISE_LOG_PRIVATE_KEYS
    }
  }

}

export {
  EXERCISE_LOG_CLASS_NAME,
  EXERCISE_LOG_KEY,
  EXERCISE_LOG_PRIVATE_KEYS,
  EXERCISE_LOG_FOREIGN_KEYS,
  EXERCISE_LOG_ASSOCIATIONS,
  EXERCISE_LOG_SCOPE
}
